import(/* webpackMode: "eager" */ "/home/runner/work/psx-frontend/psx-frontend/app/market-overview/market-stats/page.tsx");
